import axios from "axios";
import { getGeolocationData } from "./backend_helper";
import DeviceDetector from "device-detector-js";
import { getUserInfo } from "./authHelper";
import moment from "moment";
import { useEffect, useState } from "react";

const toCommaFormat = v => {
  let fmt_val = "";
  const formatter = new Intl.NumberFormat("en-US");
  try {
    fmt_val = formatter.format(v);
    if (fmt_val === "NaN") fmt_val = v;
  } catch (err) {
    console.log(err);
  }
  return fmt_val;
};

// convert a amount in number format to text format
const amountNumberToTextFrmt = val => {
  let fmt_val = val;
  if (val && /^[0-9]+$/.test(val)) {
    val = val.toString();
    let text_len = val.split(".")[0].length;
    // val to two decimal place
    const exactVal = (str_val, d) => {
      let v = "";
      try {
        v = (parseInt(str_val) / d).toFixed(2);
      } catch (err) {
        v = str_val;
      }
      return v;
    };

    switch (true) {
      case text_len <= 5:
        fmt_val = val;
        break;
      case text_len <= 7:
        fmt_val = `${exactVal(val, 100000)} Lac`;
        break;
      case text_len >= 8:
        fmt_val = `${exactVal(val, 10000000)} Cr`;
        break;
      default:
        fmt_val = val;
    }

    fmt_val = fmt_val.replace(".00", "");
  }
  // convert to comma format
  fmt_val = toCommaFormat(fmt_val);
  return fmt_val;
};

const checkPermissionStatus = (link, type) => {
  try {
    let roleWiseData = localStorage.getItem("roleWiseAccess")
      ? JSON.parse(localStorage.getItem("roleWiseAccess"))
      : [];
    if (roleWiseData?.length === 0) {
      return false;
    }
    let showLink =
      roleWiseData?.find(el => link?.includes(el?.menu_link))?.actions[type] ||
      false;
    return showLink;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const generateMaskedPII = (data = "", visibileCharacters = 4) => {
  if (!data) {
    return "";
  }

  let toUnMask = checkPermissionStatus("personal-id-info", "view_unmasked");

  if (!!toUnMask) {
    return data;
  }

  let length = data?.length || 0;

  if (length > 6) {
    let firstPart = data?.slice(0, visibileCharacters / 2);
    let lastPart = data?.slice(length - visibileCharacters / 2, length);

    let hashes = new Array(length - visibileCharacters).fill("*").join("");

    data = firstPart + hashes + lastPart;
  } else {
    data = new Array(length).fill("*").join("");
  }

  return data;
};

const generateRandomString = (length = 10) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const getDeviceDetails = userAgentString => {
  const deviceDetector = new DeviceDetector();
  const userAgent = userAgentString;
  const device = deviceDetector.parse(userAgent);

  let { client, os } = device;

  let { name: browserName, version: browserVersion } = client;
  let { name: osName, version: osVersion, platform: osPlatform } = os;

  let versionObject = {
    browser: `${browserName}/${browserVersion}`,
    os: `${osName} ${osVersion} ${osPlatform ? `(${osPlatform})` : ``}`,
  };

  return versionObject;
};

const checkDeviceType = navigator => {
  let details = navigator.userAgent;
  let regexp = /android|iphone|kindle|ipad/i;

  let isMobileDevice = regexp.test(details);
  let deviceType = "unknown";

  if (isMobileDevice) {
    if (details.toLowerCase().includes("iphone")) deviceType = "iPhone";
    if (details.toLowerCase().includes("android")) deviceType = "Android";
    if (details.toLowerCase().includes("kindle")) deviceType = "Amazon Kindle";
    if (details.toLowerCase().includes("ipad")) deviceType = "iPad";
  } else {
    deviceType = "Desktop/Laptop";
  }

  return deviceType;
};

const textCamelize = str => {
  if (!str) {
    return str;
  }
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

const getDeviceInfo = async navigator => {
  try {
    let deviceInfo = getDeviceDetails(navigator.userAgent);
    let userBrowser = deviceInfo.browser;
    let userOS = deviceInfo.os;
    let device_type = checkDeviceType(navigator);
    if (device_type != "Desktop/Laptop") {
      device_type = checkDeviceType(navigator) + "/Web";
    }

    const getGeolocationData = async () => {
      try {
        let data = {};
        await axios
          .get("https://ipapi.co/json/")
          .then(res => {
            data = res?.data || {};
          })
          .catch(err =>
            console.log("ERROR WHILE FETCHING GEOLOCATION DATA:", err)
          );
        return data;
      } catch (err) {
        // console.log(err)
        return {};
      }
    };

    const geolocationData = await getGeolocationData();

    let userLocation = `${geolocationData?.city}, ${geolocationData?.country_code}`;
    let userIP = geolocationData?.ip || "";
    return {
      device_type: device_type,
      browser: userBrowser,
      os: userOS,
      ip_address: userIP,
      location: userLocation,
    };
  } catch (err) {
    console.log(err);
    return {};
  }
};

const getCompanyTimezoneDateTime = dateTime => {
  if (!dateTime) return "";

  const adminInfo = getUserInfo();
  const companyTimezoneOffset =
    adminInfo?.companyTimeZone?.offset || "+05:30";

  const m = moment(dateTime);

  if (!m.isValid()) return "";

  return m
    .utc()
    .utcOffset(companyTimezoneOffset)
    .format();
};


const formatNullUndefined = value => {
  if ([null, undefined, "null", "undefined"].includes(value)) {
    return null;
  }

  return value;
};

const formatBoolean = value => {
  if ([true, "true"].includes(value)) {
    return true;
  }

  if ([false, "false"].includes(value)) {
    return false;
  }

  return value;
};
const formatDate = value => {
  let timestamp = new Date(value);
  let options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  let formattedDate = timestamp.toLocaleString("en-GB", options);
  return formattedDate;
};


const checkMeetingPlatform = link => {
  const zoomPattern = /zoom.us\/j\//;
  const googleMeetPattern = /meet.google.com/;
  const teamsPattern = /teams.microsoft.com|teams.live.com/;

  if (zoomPattern.test(link)) {
    return "Zoom";
  } else if (googleMeetPattern.test(link)) {
    return "Google Meet";
  } else if (teamsPattern.test(link)) {
    return "Microsoft Teams";
  } else {
    return "Unknown Platform";
  }
};

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const getRoleName = () => {
  const authUser = localStorage.getItem("authUser");
  if (!authUser) return null;

  const obj = JSON.parse(authUser);
  return obj?.user?.role_name || null;
};


   const getSubdomain = () => {
  return localStorage.getItem("subdomain")?.toLowerCase() || "";
};


export {
  amountNumberToTextFrmt,
  checkPermissionStatus,
  generateMaskedPII,
  generateRandomString,
  getDeviceInfo,
  textCamelize,
  getCompanyTimezoneDateTime,
  formatNullUndefined,
  formatBoolean,
  formatDate,
  checkMeetingPlatform,
  useDebounce,
  getRoleName,
  getSubdomain
};
